import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserService } from '../services/user.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import { MasterMOMService } from '../services/master-mom.service';
import { GenInfoAtd } from '../models/MOMForm';
@Component({
  selector: 'app-reset-meeting-action',
  templateUrl: './reset-meeting-action.component.html',
  styleUrls: ['./reset-meeting-action.component.css'],
  providers: [ToastrUtilsService]
})
export class ResetMeetingActionComponent implements OnInit {
  loginUserId: any;
  resetMeetingList: any = [];
  filterVal = new GenInfoAtd();
  isLoader: boolean = false;
  searchText: any = '';
  PostStartIndex: number = 1;
  ifcountgreaterthanzero: boolean;
  disableMore: boolean;
  PostMaxCount: number = 10;
  constructor(private modalService: BsModalService,
    private userService: UserService,
    private toastr: ToastrUtilsService,
    public utilityService: UtilityService,
    private momService: MasterMOMService,
    private _activatedRoute: ActivatedRoute) { }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!this.disableMore) {
        this.disableMore = true;

        this.getMoreItems();
      }

    }
  }
  ngOnInit(): void {
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.loginUserId = user.id;
    }
    
    this.loadGeneralInfo(true);
    this.ifcountgreaterthanzero = false;
    this.PostMaxCount = 10;
  }


  loadGeneralInfo(isStart: boolean) {
    ;
    //if (this.editPopUpClose)
    //  return;
    // Notiflix.Block.Dots('.pageloadcontainer');
    //this.filterVal.startIndex = 1;
  
    this.filterVal.userUno = this.loginUserId;
  
    this.PostStartIndex = (this.PostStartIndex == undefined || this.PostStartIndex < 1 || isStart) ? 1 : this.PostStartIndex;
    this.filterVal.startIndex = this.PostStartIndex;
    this.filterVal.maxCount = this.PostMaxCount;
    
    this.filterVal.keyword = this.searchText;

    this.momService.getResetMeetingActionAll(this.filterVal)
      .subscribe((data: any) => {

        if (this.PostStartIndex == 1) {
          this.resetMeetingList = [];
        }
        let dataItemList: any = [];
        dataItemList = data;
        for (var i = 0; i < dataItemList.length; i++) {

          this.resetMeetingList.push(dataItemList[i]);
        }

       
        console.log("resetMeetingList", data);
        this.disableMore = (dataItemList.length >= 10) ? false : true;
        if (dataItemList.length > 0) {
          this.ifcountgreaterthanzero = true;
          this.PostStartIndex = this.PostStartIndex + 1;
        }
        this.isLoader = false;
       
      },
        () => {
          this.isLoader = false;
        }
      ).add(() => {
        this.isLoader = false;
        
        // Notiflix.Block.Remove('.pageloadcontainer', 800);
        //Called when operation is complete (both success and error)

      });

  }

  getMoreItems() {
    this.loadGeneralInfo(false);
  }

  resetAction(published: any, id: any) {
    //if (this.editPopUpClose)
    //  return;
    // Notiflix.Block.Dots('.pageloadcontainer');
    //this.filterVal.startIndex = 1;

    this.filterVal.userUno = this.loginUserId;
    this.filterVal.published = published;

    this.filterVal.genInfoAtdUno = id;

    this.momService.resetMeetingAction(this.filterVal)
      .subscribe((data: any) => {

  
        if (data != "failure") {
          this.toastr.SuccessCustomMessage("Meeing Reset Successfully");
        }
        else {
          this.toastr.ErrorMessage();
        }
      },
        () => {
          this.isLoader = false;
        }
      ).add(() => {
        this.isLoader = false;

        // Notiflix.Block.Remove('.pageloadcontainer', 800);
        //Called when operation is complete (both success and error)

      });
  }
}
